import React from "react";
import { Link } from "react-router-dom";

export default function CookiePolicy() {
  return (
    <div className="container-editorial py-16 lg:py-24 max-w-3xl" data-testid="page-cookies">
      <span className="pill">Cookie</span>
      <h1 className="mt-4 font-display text-5xl sm:text-6xl tracking-tighter leading-[0.95]">Cookie Policy</h1>
      <p className="mt-4 text-viola/60 text-sm">Ultimo aggiornamento: {new Date().toLocaleDateString("it-IT", { day: "numeric", month: "long", year: "numeric" })}</p>

      <div className="mt-10 space-y-6 text-viola/85 leading-relaxed">
        <h2 className="font-display text-2xl mt-8">Cosa sono i cookie</h2>
        <p>I cookie sono piccoli file di testo memorizzati sul tuo dispositivo per far funzionare il sito, ricordare le preferenze e raccogliere statistiche anonime.</p>

        <h2 className="font-display text-2xl mt-8">Cookie utilizzati da questo sito</h2>
        <ul className="list-disc pl-6 space-y-2">
          <li><strong>Cookie tecnici (necessari)</strong>: garantiscono il funzionamento del sito (es. sessione admin autenticata, preferenza tema chiaro/scuro). Non richiedono consenso.</li>
          <li><strong>Cookie analitici anonimizzati</strong>: utilizzati solo se acconsenti — servono a capire come viene usato il sito per migliorarlo.</li>
        </ul>

        <h2 className="font-display text-2xl mt-8">Cookie di terze parti</h2>
        <p>Il sito può includere risorse di terze parti (font, embed video/podcast) che possono a loro volta impostare cookie. Ti invitiamo a consultare le policy dei rispettivi fornitori.</p>

        <h2 className="font-display text-2xl mt-8">Come gestire i cookie</h2>
        <p>Puoi gestire o disattivare i cookie dal tuo browser. Tieni presente che disabilitare i cookie tecnici può compromettere il funzionamento del sito.</p>

        <p className="mt-10 text-sm">Per maggiori informazioni sul trattamento dei dati consulta la <Link to="/privacy-policy" className="text-fucsia">Privacy Policy</Link>.</p>
      </div>
    </div>
  );
}
